import { render } from "./RecomendedView.vue?vue&type=template&id=54618e22"
import script from "./RecomendedView.vue?vue&type=script&lang=js"
export * from "./RecomendedView.vue?vue&type=script&lang=js"

import "./RecomendedView.vue?vue&type=style&index=0&id=54618e22&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__